import { css } from "emotion";
import React from "react";
import {
  determineImage,
  determineLocation,
  determineDateString,
  determingLink
} from "../../../utils/SearchUtils";
import ShareButton from "../../../components/layout/ShareButton.js";
import { max } from "../../../utils/CssUtils";
import { relative } from "path";

const freeStyling = {
  height: 30,
  backgroundColor: "#f9f9fa",
  width: 78,
  borderRadius: 4,
  display: "flex",
  alignItems: "center",
  paddingTop: 0,
  justifyContent: "center"
};

const iconPosition = css({
  position: "absolute",
  bottom: 0,
  right: 0
});

const clickableSection = css({
  minHeight: 290
});

const Card = hit => {
  const imageUrl = determineImage(hit);
  const location = determineLocation(hit);
  const date = determineDateString(hit);
  const link = determingLink(hit);

  const wrapper = css({
    position: "relative",
    borderRadius: 4,
    marginBottom: 24,
    backgroundColor: "white",
    display: "block",
    width: 248,
    minHeight: 332,
    boxShadow: "0 1px 8px 1px rgba(32, 7, 64, 0.13)",
    "&:hover": {
      boxShadow: "0 1px 8px 3px rgba(32, 7, 64, 0.13)"
    },
    h5: {
      fontSize: 18,
      fontWeight: 600,
      color: "#323232",
      padding: "0px 12px",
      maxHeight: 48,
      overflow: "hidden",
      textOverflow: "ellipsis",
      marginBottom: 8,
      maxHeight: 72,
      whiteSpace: "normal",
      maxHeight: hit.preventMobile ? 50 : 74
    },
    img: {
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      marginBottom: 16,
      width: "100%"
    },
    [max(530)]: {
      minHeight: hit.preventMobile ? "332" : "none",
      maxWidth: hit.preventMobile ? 248 : "calc(100vw - 28px)",
      width: hit.preventMobile ? 248 : "calc(100vw - 28px)"
    }
  });

  const dateStyle = css({
    fontSize: 14,
    color: "#6621c0",
    paddingLeft: 12,
    paddingRight: 12,
    marginBottom: 8,
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 224,
    whiteSpace: "nowrap",
    [max(530)]: {
      maxWidth: hit.preventMobile ? 248 : "calc(100vw - 28px)"
    }
  });

  const informationStyle = css({
    fontSize: 14,
    color: "#323232",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 224,
    paddingLeft: 12,
    paddingRight: 12,
    whiteSpace: "nowrap",
    [max(530)]: {
      maxWidth: hit.preventMobile ? 248 : "calc(100vw - 28px)"
    }
  });

  const priceWrapper = {
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    padding: "10px 12px",
    fontSize: 14,
    fontWeight: 600,
    position: "absolute",
    bottom: 0,
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    div: {
      height: 30,
      paddingTop: 7
    },
    [max(530)]: {
      position: hit.preventMobile ? "absolute" : "relative"
    }
  };
  if (hit.priceString === "FREE") {
    priceWrapper.div = { ...freeStyling };
  }
  return (
    <div>
      <div className={wrapper}>
        <a href={link}>
          <div className={clickableSection}>
            <img src={imageUrl} />
            <p className={dateStyle}>{date}</p>
            <h5>{hit.name}</h5>
            <p className={informationStyle}>{location}</p>
          </div>
        </a>
        <div className={css(priceWrapper)}>
          {hit.priceString !== "FREE" ? <div /> : <div>Free</div>}
          <ShareButton link={link} />
        </div>
      </div>
    </div>
  );
};

export default Card;
